(function($) {
	'use strict';
	$.widget('msv.articleList', {
		vars: {},
		el: {},
		_create: function() {
			//---------- define vars and elements -----------------------------
			this.el.filtersForm = this.element.find('.js-filter-form');
			this.el.listContainer = this.element.find('.js-container');
			this.el.loadMore = this.element.find('.js-load-more');

			this.vars.endpoint = this.element.data('endpoint');
			this.vars.start = this.element.data('start');
			this.vars.contentId = this.element.data('content-id');
			this.vars.pageSize = this.element.data('pagesize') ? this.element.data('pagesize') : 10;
			this.vars.isLoading = false;
		},
		_init: function() {
			var self = this;
			//---------- define events ---------------------------------
			self.el.filtersForm.off('change').change(function() {
				self.vars.start = 0;
				$(self.el.main).data('start', self.vars.start);
				self.el.listContainer.html(null);
				self.loadContainer();
			});


			self.el.loadMore.off('click').click(function() {
				self.loadContainer();
			});
		},
		_destroy: function() {},
		loadContainer: function() {
			var self = this;

			//prevent to load when it is already loading
			if (self.vars.isLoading)
				return;

			var params = self.el.filtersForm.serialize();
			params += '&start=' + self.vars.start;
			params += '&pageSize=' + self.vars.pageSize;
			if (self.vars.contentId)
				params += '&contentId=' + self.vars.contentId;

			//add loading state to button
			self.el.loadMore.attr('disabled', true).addClass('btn-loading');
			self.el.loadMore.append("<span class='btn-loading-spinner'></span>");
			self.vars.isLoading = true;
			//ajax request
			$.get(self.vars.endpoint, params, function(data, m, e) {
				self.vars.isLoading = false;

				if (self.vars.start == 0)
					self.el.listContainer.html(data);
				else
					self.el.listContainer.append(data);

				self.el.loadMore.removeClass('loading');
				if (e.status == 200) {
					self.el.loadMore.hide();
				}
				else if (e.status == 202) {
					self.el.loadMore.show();
					self.vars.start += self.vars.pageSize;
					$(self.element).data('start', self.vars.start);
				}

				//remove loading state from button                
				self.el.loadMore.attr('disabled', false).removeClass('btn-loading');
				self.el.loadMore.find(".btn-loading-spinner").remove();
			});
		}
	});
})(jQuery);